import { HTTPWithInterceptors } from './http'

const API_DOMAIN = '/'
const API_VERSION = 'v1'

export const beian = HTTPWithInterceptors(API_DOMAIN, 10)
const api = HTTPWithInterceptors(API_DOMAIN + API_VERSION, 10)

export default api



// WEBPACK FOOTER //
// ./src/server/beian.js